import { render, staticRenderFns } from "./CommonPopUp.vue?vue&type=template&id=0084ebe2&scoped=true&"
import script from "./CommonPopUp.vue?vue&type=script&lang=js&"
export * from "./CommonPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CommonPopUp.vue?vue&type=style&index=0&id=0084ebe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084ebe2",
  null
  
)

export default component.exports